// Krok dostawy miedzy koszykiem a kasa: mapa Furgonetki, zapis w atrybutach koszyka, adres punktu w kasie.
(function () {
  const ROOT = '[data-vonare-pickup]';
  const MAP_SCRIPT = 'https://furgonetka.pl/js/dist/map/map.js';
  const STEP_URL = `${window.Shopify?.routes?.root || '/'}cart?view=dostawa`;
  const NETWORK_NAMES = {
    inpost: 'InPost',
    orlen: 'ORLEN Paczka',
    dpd: 'DPD Pickup',
    dhl: 'DHL',
    izidrop: 'Żabka',
    poczta: 'Poczta Polska',
    ups: 'UPS',
    gls: 'GLS',
    fedex: 'FedEx',
  };
  let saving = Promise.resolve();
  let mapScript = null;
  let hadPoint = false;

  const style = document.createElement('style');
  style.textContent = `
    .vonare-pickup { width: 100%; display: flex; flex-direction: column; gap: 8px; text-align: start; font-size: 14px; line-height: 1.35; color: var(--color-foreground); }
    .vonare-pickup__options { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
    .vonare-pickup__option { display: flex; align-items: center; gap: 8px; min-height: 44px; padding: 8px 10px; border: 1px solid var(--color-border, #dfdfdf); border-radius: 8px; cursor: pointer; }
    .vonare-pickup__option:has(input:checked) { border-color: var(--color-foreground); box-shadow: inset 0 0 0 1px var(--color-foreground); }
    .vonare-pickup__option input { flex: none; margin: 0; accent-color: var(--color-foreground); }
    .vonare-pickup__panel { display: flex; flex-direction: column; gap: 6px; }
    .vonare-pickup__panel[hidden], .vonare-pickup__error[hidden], .vonare-pickup__chosen[hidden], .vonare-pickup__hint[hidden] { display: none; }
    .vonare-pickup__chosen, .vonare-pickup__hint, .vonare-pickup__error { margin: 0; }
    .vonare-pickup__chosen { font-weight: 600; }
    .vonare-pickup__hint { font-size: 12px; color: var(--color-foreground-subdued, #555); }
    .vonare-pickup__error { font-size: 13px; font-weight: 600; color: #b3261e; }
    .vonare-pickup__open { width: 100%; min-height: 44px; padding: 8px 12px; background: transparent; color: var(--color-foreground); border: 1px solid var(--color-foreground); border-radius: 8px; font: inherit; font-weight: 600; cursor: pointer; }
    .vonare-pickup-dialog { width: min(1100px, calc(100vw - 24px)); height: min(800px, calc(100dvh - 24px)); max-width: none; max-height: none; padding: 0; border: 0; border-radius: 8px; background: #fff; color: #111; }
    .vonare-pickup-dialog[open] { display: flex; flex-direction: column; }
    .vonare-pickup-dialog::backdrop { background: rgb(0 0 0 / 0.55); }
    .vonare-pickup-dialog__head { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-bottom: 1px solid #dfdfdf; font-size: 16px; font-weight: 600; }
    .vonare-pickup-dialog__close { min-width: 44px; min-height: 44px; background: none; border: 0; font-size: 24px; line-height: 1; cursor: pointer; color: inherit; }
    #vonare-pickup-map { flex: 1; min-height: 0; position: relative; }
    .vonare-pickup-dialog__message { padding: 24px 16px; margin: 0; font-size: 14px; }
  `;
  document.head.append(style);

  function save(attributes) {
    saving = saving
      .then(() =>
        fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        })
      )
      .catch(() => {});
    return saving;
  }

  function paint(root) {
    const pickup = root.dataset.mode === 'punkt';
    const code = root.dataset.code || '';
    root.querySelector('[data-vp-panel]').hidden = !pickup;
    const chosen = root.querySelector('[data-vp-chosen]');
    chosen.hidden = !code;
    chosen.textContent = code ? `${root.dataset.network}: ${root.dataset.name} (${code})` : '';
    root.querySelector('[data-vp-open]').textContent = code ? 'Zmień punkt' : 'Wybierz punkt na mapie';
    const hint = root.querySelector('[data-vp-hint]');
    hint.hidden = !code;
    hint.textContent = 'Adres punktu pojawi się w kasie. Uzupełnij imię, nazwisko i telefon, a potem wybierz dostawę do punktu.';
    if (code || !pickup) root.querySelector('[data-vp-error]').hidden = true;
    root.querySelector(`input[value="${pickup ? 'punkt' : 'kurier'}"]`).checked = true;
  }

  function setPoint(root, point) {
    const network = NETWORK_NAMES[point.type] || point.type;
    Object.assign(root.dataset, { mode: 'punkt', code: point.code, name: point.name, network });
    paint(root);
    save({
      Dostawa: 'Punkt odbioru',
      'Punkt odbioru': point.name,
      'Kod punktu': point.code,
      'Sieć punktu': network,
      'Pobranie w punkcie': point.cod ? 'tak' : 'nie',
    });
  }

  function setCourier(root) {
    Object.assign(root.dataset, { mode: 'kurier', code: '', name: '', network: '' });
    paint(root);
    save({ Dostawa: 'Kurier', 'Punkt odbioru': '', 'Kod punktu': '', 'Sieć punktu': '', 'Pobranie w punkcie': '' });
  }

  function checkoutUrl(address) {
    const params = new URLSearchParams();
    params.set('checkout[shipping_address][country]', 'PL');
    Object.entries(address).forEach(([key, value]) => params.set(`checkout[shipping_address][${key}]`, value));
    return `${window.Shopify?.routes?.root || '/'}checkout?${params}`;
  }

  // Nazwa punktu z mapy ma postac "KOD - Ulica 1, 87-100 Miasto" albo "ULICA 1, Miasto".
  function pickupAddress(root) {
    const { code, network } = root.dataset;
    const name = (root.dataset.name || '').replace(`${code} - `, '');
    const comma = name.lastIndexOf(',');
    const street = comma > -1 ? name.slice(0, comma).trim() : name.trim();
    const place = comma > -1 ? name.slice(comma + 1).trim() : '';
    const zip = place.match(/\d{2}-\d{3}/)?.[0] || '';
    return { address1: `${network} ${code}, ${street}`, zip, city: place.replace(zip, '').trim() };
  }

  function getDialog() {
    let dialog = document.getElementById('vonare-pickup-dialog');
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = 'vonare-pickup-dialog';
    dialog.className = 'vonare-pickup-dialog';
    dialog.setAttribute('aria-label', 'Wybierz punkt odbioru');
    dialog.innerHTML =
      '<div class="vonare-pickup-dialog__head"><span>Wybierz punkt odbioru</span>' +
      '<button type="button" class="vonare-pickup-dialog__close" aria-label="Zamknij">×</button></div>' +
      '<div id="vonare-pickup-map"></div>';
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    document.body.append(dialog);
    return dialog;
  }

  function loadMapScript() {
    if (window.Furgonetka) return Promise.resolve();
    if (mapScript) return mapScript;
    mapScript = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = MAP_SCRIPT;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    }).catch((error) => {
      mapScript = null;
      throw error;
    });
    return mapScript;
  }

  async function openMap(root) {
    const dialog = getDialog();
    const container = dialog.querySelector('#vonare-pickup-map');
    container.replaceChildren();
    dialog.showModal();
    try {
      await loadMapScript();
      new window.Furgonetka.Map({
        apiKey: root.dataset.key,
        courierServices: root.dataset.networks.split(',').map((item) => item.trim()).filter(Boolean),
        container: '#vonare-pickup-map',
        locale: 'pl',
        callback: (params) => {
          setPoint(root, params.point);
          dialog.close();
        },
      }).show();
    } catch (error) {
      const message = document.createElement('p');
      message.className = 'vonare-pickup-dialog__message';
      message.textContent = 'Mapa się nie wczytała. Odśwież stronę albo napisz na kontakt@vonare.pl.';
      container.replaceChildren(message);
    }
  }

  function continueToCheckout(root, link) {
    if (root.dataset.mode === 'punkt') {
      if (!root.dataset.code) {
        root.querySelector('[data-vp-error]').hidden = false;
        root.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      saving.then(() => {
        window.location.href = checkoutUrl(pickupAddress(root));
      });
      return;
    }
    // Kurier po wczesniejszym wyborze punktu: adres punktu nie moze zostac w kasie.
    if (!hadPoint) save({ Dostawa: 'Kurier' });
    saving.then(() => {
      window.location.href = hadPoint ? checkoutUrl({ address1: '', zip: '', city: '' }) : link.href;
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-vonare-pickup] input[type="radio"]');
    if (!input) return;
    const root = input.closest(ROOT);
    if (input.value === 'kurier') {
      setCourier(root);
    } else {
      root.dataset.mode = 'punkt';
      paint(root);
      save({ Dostawa: 'Punkt odbioru' });
    }
  });

  document.addEventListener('click', (event) => {
    const open = event.target.closest?.('[data-vp-open]');
    if (open) {
      openMap(open.closest(ROOT));
      return;
    }

    const next = event.target.closest?.('[data-vp-continue]');
    if (next) {
      const root = document.querySelector(ROOT);
      if (!root) return;
      event.preventDefault();
      continueToCheckout(root, next);
      return;
    }

    if (event.target.closest?.('#checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = STEP_URL;
    }
  }, true);

  document.querySelectorAll(ROOT).forEach((root) => {
    hadPoint = Boolean(root.dataset.code);
    paint(root);
  });
})();
